var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var React = require('react');
module.exports = function useImage(url, crossOrigin, referrerpolicy) {
  // lets use refs for image and status
  // so we can update them during render
  // to have instant update in status/image when new data comes in
  var statusRef = React.useRef('loading');
  var imageRef = React.useRef();

  // we are not going to use token
  // but we need to just to trigger state update
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    _ = _React$useState2[0],
    setStateToken = _React$useState2[1]; // keep track of old props to trigger changes
  var oldUrl = React.useRef();
  var oldCrossOrigin = React.useRef();
  var oldReferrerPolicy = React.useRef();
  if (oldUrl.current !== url || oldCrossOrigin.current !== crossOrigin || oldReferrerPolicy.current !== referrerpolicy) {
    statusRef.current = 'loading';
    imageRef.current = undefined;
    oldUrl.current = url;
    oldCrossOrigin.current = crossOrigin;
    oldReferrerPolicy.current = referrerpolicy;
  }
  React.useLayoutEffect(function () {
    if (!url) return;
    var img = document.createElement('img');
    function onload() {
      statusRef.current = 'loaded';
      imageRef.current = img;
      setStateToken(Math.random());
    }
    function onerror() {
      statusRef.current = 'failed';
      imageRef.current = undefined;
      setStateToken(Math.random());
    }
    img.addEventListener('load', onload);
    img.addEventListener('error', onerror);
    crossOrigin && (img.crossOrigin = crossOrigin);
    referrerpolicy && (img.referrerpolicy = referrerpolicy);
    img.src = url;
    return function cleanup() {
      img.removeEventListener('load', onload);
      img.removeEventListener('error', onerror);
    };
  }, [url, crossOrigin, referrerpolicy]);

  // return array because it it better to use in case of several useImage hooks
  // const [background, backgroundStatus] = useImage(url1);
  // const [patter] = useImage(url2);
  return [imageRef.current, statusRef.current];
};